var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              staticClass: "uploadBefore",
              attrs: {
                limit: _vm.limitNumber,
                action: "",
                accept: "image/*",
                "http-request": _vm.uploadFile,
                "auto-upload": true,
                "on-preview": _vm.handlePictureCardPreview,
                "on-exceed": _vm.handleExceed,
                "before-remove": _vm.beforeRemove,
                "show-file-list": false,
              },
            },
            [
              _vm.type == 0
                ? _c("div", [
                    _vm.imageUrl
                      ? _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.imageUrl },
                        })
                      : _c("i", { staticClass: "el-icon-plus icon" }),
                  ])
                : _vm._e(),
              _vm.type == 1
                ? _c("div", [
                    _vm.imageUrl1
                      ? _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.imageUrl1 },
                        })
                      : _c("div", { staticClass: "avatarNone" }, [
                          _c(
                            "div",
                            { staticStyle: { "padding-top": "24px" } },
                            [
                              _c("img", {
                                staticStyle: { width: "64px", height: "50px" },
                                attrs: {
                                  src: require("../../../assets/xiangji.png"),
                                },
                              }),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "18px",
                                "font-family": "PingFang SC",
                                "font-weight": "400",
                                "line-height": "32px",
                                color: "#4168e7",
                              },
                            },
                            [_vm._v("上传身份证正面")]
                          ),
                        ]),
                  ])
                : _vm._e(),
              _vm.type == 2
                ? _c("div", [
                    _vm.imageUrl2
                      ? _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.imageUrl2 },
                        })
                      : _c("div", { staticClass: "avatarNone" }, [
                          _c(
                            "div",
                            { staticStyle: { "padding-top": "24px" } },
                            [
                              _c("img", {
                                staticStyle: { width: "64px", height: "50px" },
                                attrs: {
                                  src: require("../../../assets/xiangji.png"),
                                },
                              }),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "18px",
                                "font-family": "PingFang SC",
                                "font-weight": "400",
                                "line-height": "32px",
                                color: "#4168e7",
                              },
                            },
                            [_vm._v("上传身份证反面")]
                          ),
                        ]),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }